var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCiti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8 88.5004C34.9 92.2004 30.4 94.5004 25.4 94.5004C16.7 94.5004 9.6 87.4004 9.6 78.7004C9.6 70.0004 16.7 62.9004 25.4 62.9004C30.1 62.9004 34.4 65.0004 37.3 68.3004L43.2 60.8004C38.6 56.2004 32.3 53.4004 25.4 53.4004C11.3 53.4004 0 64.7004 0 78.7004C0 92.7004 11.3 104 25.3 104C32.3 104 38.6 101.2 43.2 96.6004L37.8 88.5004Z",
    fill: "#013B6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0008 54.4004H48.3008V103.5H59.0008V54.4004Z",
    fill: "#013B6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.302 54.5996H106.602V103.7H117.302V54.5996Z",
    fill: "#013B6F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2992 104C79.0992 104 76.8992 96.2004 76.6992 91.7004H76.5992V63.7004H67.1992V54.7004H76.5992V45.2004L86.0992 39.4004L85.7992 46.7004V54.7004H95.3992V63.7004H85.7992V88.6004C85.6992 88.9004 85.6992 89.3004 85.6992 89.7004C85.6992 90.1004 85.6992 90.4004 85.7992 90.8004V91.4004C86.1992 93.6004 87.5992 95.4004 89.5992 96.2004C90.3992 96.5004 91.1992 96.7004 92.0992 96.7004C94.0992 96.7004 95.8992 95.8004 97.0992 94.4004C97.3992 94.1004 97.5992 93.7004 97.7992 93.4004C97.8992 93.1004 98.0992 104 88.2992 104Z",
    fill: "#013B6F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9008 88.5V90.6C85.8008 90.3 85.8008 89.9 85.8008 89.5C85.8008 89.2 85.8008 88.8 85.9008 88.5Z",
    fill: "#00DFA2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 23.9004C66.4 23.9004 50.3 33.1004 41 47.1004H56.1C63.4 40.0004 73.4 35.5004 84.4 35.5004C95.4 35.5004 105.4 39.9004 112.7 47.1004H128C118.7 33.3004 102.7 23.9004 84.5 23.9004Z",
    fill: "#D72818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiti);
export default __webpack_public_path__ + "static/media/citi - ซิตี้แบงก์.5bdebc261c2ccd98871bd6b96bba5cf6.svg";
export { ForwardRef as ReactComponent };